import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from "../../views/Components/Dialog/Dialog";

class ActivateDeactivateUserDialog extends Component{
  propTypes = {
    open: PropTypes.bool,
    activate: PropTypes.bool,
    onClose: PropTypes.func,
    onConfirm: PropTypes.func,
  };

  render() {
    const {open, activate, onClose, onConfirm} = this.props;
    return (
      <Dialog
        open={open}
        onClose={onClose}
        title={(activate ? 'Activate' : 'Deactivate') + " User"}
        confirmButtonText={"Yes"}
        onConfirm={onConfirm}
        closeButtonText={"No"}
      >
        <div className={"text-center"}>
          Are you sure you want to {activate ? 'activate' : 'deactivate'} this user?
          {!activate && (
            <>
              <br />
              <p key={4} className="mt-3 text-muted">Note: Open (not complete) interviews and active jobs managed by deactivated user will be transferred to the team manager, or the company admin if a team manager has not been appointed.</p>
            </>
          )}
        </div>
      </Dialog>
    )
  }
}

export default ActivateDeactivateUserDialog;
